import { Children, type ReactNode, type FC, type PropsWithChildren } from "react";
import { Skeleton } from "@mantine/core";

export interface ComponentWithLoaderProps {
  isLoading: boolean;
};

export const InjectSkeletonLoaders: FC<PropsWithChildren & ComponentWithLoaderProps> = ({ children, isLoading }) =>
  Children.map(children, (child): ReactNode => isLoading ? <Skeleton h="lg" my={8} /> : child);
